import * as React from "react";
import { useState } from "react";
import { UserStore } from "../../../Stroes/Variable";
import { ActionType } from "../../../../../react-core/Flux/ActionType";
import { InvestmentType } from "../../../../../Wrap/Constants/Enums/InvestmentType";
import { ServiceProposition } from "../../../../../Wrap/Constants/Enums/ServiceProposition";
import { SearchTabs } from "../../../../Shared/IST/Components/Shared/SearchTabs";
import { investmentType } from "../../../../Shared/IST/Resource/Content";
import { Navigator } from "../../../../Shared/Wizards/Entities/Navigator";
import { Urls } from "../../../Urls";
import { ResearchISTDispatcher } from "../Store/Variable";
import { ResearchResultTable } from "./ResearchResultTable";
import { CashDepositResearchResultTable } from "./CashDepositResearchResultTable";

export const ResearchInvestmentSelection = () => {
    const [tab, setTab] = useState(InvestmentType.Funds);
    const userInfo = UserStore.getUserInfo();
    const serviceProposition = userInfo.ServiceProposition;
    return (
        <>
            <h1>Fund research</h1>
            <button
                className="hyperlink"
                onClick={() => {
                    Navigator.navigateTo(Urls.get().main.ToolAndLiterature);
                }}
            >
                {"< Back to tools & literature"}
            </button>
            <div className="module mt-11 ist-wrap">
                <h2>Search for investments</h2>
                <SearchTabs
                    hiercharyId={null}
                    product={null}
                    data={[]}
                    isUnderTransfer
                    onTabClick={(tab) => {
                        setTab(tab);
                        ResearchISTDispatcher.dispatch({ actionType: ActionType.Success, payload: null });
                    }}
                    researchIst
                    accountServiceProposition={serviceProposition ? serviceProposition[0] : ServiceProposition.Wrap}
                    canBeBought={true}
                    canBeSold={false}
                    includeInsuredFund={true}
                    companyServiceProposition={[]}
                />
                {tab != InvestmentType.CashDeposits &&
                    <ResearchResultTable tab={tab} />
                }
                {tab == InvestmentType.CashDeposits &&
                    <CashDepositResearchResultTable tab={tab} />
                }
            </div>
        </>
    );
};
